import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, getTrackByFn, InputObservable } from '@y42/angular/util';
import { ColumnTypeEnum } from '@y42/json-schema';
import { isNotNullish } from '@y42/util/nullish';
import { combineLatest, filter, map, Observable, startWith, switchMap } from 'rxjs';
import { ColumnDataType } from '../column-data-type.model';
import { ColumnTypesStateService } from '../column-types-state.service';

@UntilDestroy()
@Component({
  selector: 'y42-column-type-select[formCtrl]',
  templateUrl: './column-type-select.component.html',
  styleUrls: ['./column-type-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnTypeSelectComponent {
  constructor(private readonly columnTypesStateService: ColumnTypesStateService) {}

  @Input()
  @InputObservable()
  formCtrl!: FormControl<ColumnTypeEnum | null>;
  private readonly formCtrl$!: Observable<FormControl<ColumnTypeEnum | null>>;

  readonly trackByName = getTrackByFn<ColumnDataType>('name');

  private readonly columnTypes$ = this.columnTypesStateService.select(
    (x) => x.entityState?.filter((col) => isNotNullish(col.columnType)) ?? [],
  );

  readonly state = connectState(this, {
    columnTypes: this.columnTypes$,
    selectedColumnType: combineLatest([this.formCtrl$, this.columnTypes$]).pipe(
      filter(([formCtrl]) => !!formCtrl),
      switchMap(([formCtrl, columnTypes]) =>
        formCtrl.valueChanges.pipe(
          startWith(formCtrl.value),
          map((value) => columnTypes.find((columnType) => columnType.columnType === value)?.name || ''),
        ),
      ),
    ),
  });
}
